<div class="pension-other-funds-page w-full max-w-6xl">
    <div class="intro-block">
        <h2>Umsóknir frá öðrum sjóðum</h2>
        <p>Hér er hægt að skrá umsóknir sem berast LSR sem PDF skjöl frá öðrum lífeyrissjóðum.</p>
    </div>

    <mat-form-field class="application-type-select">
        <mat-label>Tegund umsóknar</mat-label>
        <mat-select [value]="selectedApplicationType" (selectionChange)="switchApplicationType($event.value)">
            <ng-container *ngFor="let option of applicationTypeOptions">
                <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>

    @if (selectedApplicationType === retirementApplicationType) {
        <app-pension-retirement-form (submitted)="onSubmitted($event)" (inputStarted)="clearResult()"></app-pension-retirement-form>
    }

    @if (selectedApplicationType === spouseApplicationType) {
        <app-pension-spouse-form (submitted)="onSubmitted($event)" (inputStarted)="clearResult()"></app-pension-spouse-form>
    }

    @if (submitResult) {
        <div class="result-card">
            <h3>Umsókn skráð</h3>
            <p>
                Umsóknarnúmer: <strong>{{ submitResult.applicationIdentifier }}</strong>
            </p>
        </div>
    }
</div>
